module.exports = __webpack_public_path__ + "static/media/texture-season-2.0a08e4de.jpg";